import { useCallback, useEffect, useRef, useState } from 'react';
import { GA_CONSENT_COOKIE } from '@rio-cloud/rio-user-menu-component';

export const useCookiesDisclaimer = () => {
    const cookieExists = useCallback((cookieName: string) => document.cookie.split(';').some((cookie) => cookie.trim().startsWith(`${cookieName}=`)), []);

    const [enableCookieDisclaimer, setEnableCookieDisclaimer] = useState(!cookieExists(GA_CONSENT_COOKIE));
    const prevValueOfEnableCookieDisclaimer = useRef(enableCookieDisclaimer);

    useEffect(() => {
        if (prevValueOfEnableCookieDisclaimer.current && !enableCookieDisclaimer) {
            location.reload();
        }

        prevValueOfEnableCookieDisclaimer.current = enableCookieDisclaimer;
    }, [enableCookieDisclaimer]);

    return { enableCookieDisclaimer, setEnableCookieDisclaimer };
};
